/**
 * Turns a failed Strapi save into a message the user can act on. A unique
 * violation names the field ("Contract number already exists") using
 * `fieldLabels`; any other failure keeps the caller's generic `fallback`.
 */
export const getApiErrorMessage = (
  error: any,
  fallback: string,
  fieldLabels: Record<string, string> = {}
): string => {
  const details = error?.response?.data?.error?.details?.errors;
  if (Array.isArray(details)) {
    const unique = details.find((detail: any) =>
      /must be unique/i.test(detail?.message || "")
    );
    if (unique) {
      const field = unique.path?.[0];
      return `${fieldLabels[field] || field || "A unique value"} already exists`;
    }
  }
  return fallback;
};

export const CONTRACT_FIELD_LABELS = { contractNo: "Contract number" };
export const LTA_FIELD_LABELS = { ltaNumber: "LTA number" };
